<template>
  <div>
    <v-menu
      v-for="([text, rounded], index) in btns"
      :key="text"
      :rounded="rounded"
      offset-y
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          small
          elevation="0"
          light
          :color="menuColor"
          :class="textColorClass"
          class="text-capitalize"
          v-bind="attrs"
          v-on="on"
          @click="goto('/')"
        >
          <v-icon
            left
            dark
          >
            home
          </v-icon>
          {{ text }}
        </v-btn>
      </template>

    </v-menu>
  </div>
</template>

<script>
export default {
  name: "HomeNavigation",
  data: () => ({
    btns: [
      ['Home', '0'],
    ],
    colors: ['deep-purple accent-4', 'error', 'teal darken-1'],
    items: [
        'Out of Area'

    ],
    menuRoutes: [
      'overwatch',
    ],
  }),
  computed: {
    isRouteInMenu () {
      return this.menuRoutes.includes(this.$route.name)
    },
    menuColor () {
      if (this.isRouteInMenu) {
        return 'deep-purple accent-4'
      }
      return ''
    },
    textColorClass () {
      if (this.isRouteInMenu) {
        return 'white--text'
      }
      return ''
    }
  },
  methods: {
    goto (route, isNewTab = false) {
      if (isNewTab) {
        return window.open(route)
      }
      return this.$router.push(route)
    }
  }
}
</script>

<style scoped>

</style>